module.exports = __webpack_public_path__ + "img/transporter-0.823a6b6e.png";